import * as zod from 'zod';

import { TAXEL_COUNT } from '../constants';

export const RobotiqTSF85FingerState = zod.object({
  fingerIndex: zod.number().int(),
  taxels: zod.array(zod.number()).length(TAXEL_COUNT),
  forceNewtons: zod.number().default(0),
  dynamicRaw: zod.number().default(0),
  isConnected: zod.boolean().default(false),
});

export type RobotiqTSF85FingerState = zod.infer<typeof RobotiqTSF85FingerState>;

export const RobotiqTSF85State = zod.object({
  kind: zod.literal('RobotiqTSF85'),
  isConnected: zod.boolean().default(false),
  error: zod.string().optional(),
  // False until a baseline has been captured, in which case the readings carry
  // the sensor's resting offset rather than measuring from it.
  isTared: zod.boolean().default(false),
  fingers: zod.array(RobotiqTSF85FingerState).default([]),
});

export type RobotiqTSF85State = zod.infer<typeof RobotiqTSF85State>;
